import { useState, useEffect, useCallback } from "react";
import { PurchaseOrder } from "@po-management/types";
import { useApiClient } from "../../auth/useApiClient";

export function usePOs(): { pos: PurchaseOrder[]; loading: boolean; error: string | null; refetch: () => void } {
  const [pos, setPos] = useState<PurchaseOrder[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const { get } = useApiClient();

  const fetch = useCallback((): void => {
    setLoading(true);
    setError(null);
    get("/api/pos")
      .then((r) => r.json())
      .then((body: { success: boolean; data: PurchaseOrder[] }) => {
        if (body.success) setPos(body.data);
        else setError("Failed to load purchase orders");
      })
      .catch(() => setError("Failed to load purchase orders"))
      .finally(() => setLoading(false));
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => { fetch(); }, [fetch]);

  return { pos, loading, error, refetch: fetch };
}
